import barba from '@barba/core'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// Components
import { Navigation } from './navigation.js';
import { initAlpine } from './alpine.js';
import { initLenis, scrollToStart, scrollToHash } from './lenis.js';
import { initFormie } from './formie.js';
import { initSwiper } from './swiper.js'; 
import { initEnterAnimation } from './animation.js';
import { initInviewAnimations } from './inview.js';
import { initDiagram } from './diagram.js';
import { initStats } from './stats.js';
import { initPreloader } from './preloader.js';
import { initParallax } from './parallax.js';
import { initApproach } from './approach.js';
import { initComparison } from './comparison.js';
import { initExpand } from './expand.js';
import { initProcess } from './process.js';
import { initHtmx, processHtmx } from './htmx.js';
import { initAnchoredLinks } from './anchored-links.js';
import { initInsights } from './insights.js';
import { initVideos } from './video.js';

import { initBackground } from './background.js';
import { initBackground2, setGradientColour } from './background2.js';

gsap.registerPlugin(ScrollTrigger)

export const initBarba = () => {
	window.initialLoad = true

	const nav = new Navigation()

	const initComponents = (data) => {
		initSwiper()
		initPreloader()
		initEnterAnimation()
		initInviewAnimations()
		initStats()
		initDiagram()
		initParallax()
		initApproach()
		initComparison()
		initExpand()
		initProcess()
		initAnchoredLinks()

		document.fonts.ready.then(() => {
			ScrollTrigger.refresh()
		})
	}

	barba.init({
		debug: true,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'basic-transition',
				once(data) { },
				leave(data) {
          const done = this.async()

					gsap.to(data.next.container, {
						opacity: 1,
						duration: 0.5,
						ease: 'power2.inOut',
						onComplete: done
					})
				},
				afterLeave() {
					scrollToStart()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
          const done = this.async()

					gsap.from(data.next.container, {
						opacity: 0,
						duration: 0.5,
						ease: 'power2.inOut',
						onComplete: done
					})
				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initHtmx()
		initInsights()
		// initBackground()
		initBackground2()
		setGradientColour(data.next.container.dataset.gradientColour)
		initComponents(data)
		initVideos(data.next.container)
		scrollToHash()

		window.onload = function() {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.beforeEnter((data) => {
		setGradientColour(data.next.container.dataset.gradientColour)
	})

	barba.hooks.enter((data) => {
		processHtmx(data.next.container)
		initVideos(data.next.container)
	})

	barba.hooks.after((data) => {
		initComponents(data)
		initFormie()
		scrollToHash(data.trigger?.hash ?? data.next.url.hash)
	})
}
